import '../scss/module_book_visitor.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';

import { initFirebaseApp } from './module_firebase';
import { 
    manageLogin,
    openSignInModal,
 } from './module_auth_helper';

import {
    funnelUpdateWhenAvailable,
    isMobileTabletCheck,
} from './module_common';

import { initTooltip } from './module_tooltip';

import { attachReadMoreClick } from './module_readmore';

import './module_common_actions';

import { attachCtaActions } from './module_actions';

import { initNavbarVisitor } from './module_header';

const favouriteSelector = '.add-to-favourite-attach-clk';

const onPlayerClickForCantRead = function(event){
    const target = $(event.target)
    // first chapter always free
    const firstRow = target.parents(".toc-chapter-row"+"[data-chapterid=0]").length
    if (firstRow !== 0) return
    event.stopPropagation()
    manageSigniIn()
}

const attachVisitorClick = function(){
    $(".visitor-attach-clk").click(function(){
        manageSigniIn()
    })
}

const visitorAttachFavouriteClick = function(){
    $(favouriteSelector).click(function(e){
        manageSigniIn()
    })
}

const manageSigniIn = function(){
    openSignInModal()
}

const visitorAttachPlayerClick = function(){
    $(".player-wrap").click(function(e){
        const target = $(e.target)
        const header = target.parents("#heading-bc").length
        if (header !== 0) return    // exclude accordion header click
        onPlayerClickForCantRead(e)
    })
}

const visitorCloseMobileToc = function(){
    if (isMobileTabletCheck()){
        $("#table-of-content").collapse('hide')
    }
}

$(function () {
    initFirebaseApp()
    manageLogin()
    
    doLast()
    initNavbarVisitor()

    initTooltip()

    attachVisitorClick()
    
    attachCtaActions()
    
    visitorAttachFavouriteClick()
    visitorAttachPlayerClick()
    visitorCloseMobileToc()
    
    attachReadMoreClick()
    
    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('book_viewed')

});
